// LogoutComponent.jsx

import { useAuth } from '../authContext';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LogoutComponent = () => {
    const auth = useAuth();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleLogout = () => {
        auth.logout();
        navigate('/');
    };

    return (
        <button onClick={handleLogout}>
            {t('logout')}
        </button>
    );
};

export default LogoutComponent;